import { Loader } from 'rsuite';
import { ActionFeedbackDialog } from '../../../../../components';
import { PriceListRerunResponse } from '../../../../../services/PriceListRerunService';
import { previewCounts } from './priceListRerunContent';
import { RerunCountList } from './RerunCountList';
import { RerunDialogState } from './types';
import styles from './PriceListRerunCard.module.scss';

type PriceListRerunDialogsProps = {
  dialog: RerunDialogState;
  onClose: () => void;
  onConfirm: (preview: PriceListRerunResponse) => void;
};

const hasSkipped = (preview: PriceListRerunResponse) => (preview.skippedApplied ?? 0) + (preview.skippedOther ?? 0) > 0;

export const PriceListRerunDialogs = ({ dialog, onClose, onConfirm }: PriceListRerunDialogsProps) => {
  const confirmPreview = dialog?.type === 'confirm' || dialog?.type === 'starting' ? dialog.preview : null;
  const starting = dialog?.type === 'starting';

  return (
    <>
      <ActionFeedbackDialog
        open={dialog?.type === 'previewing'}
        type="other"
        icon={<Loader size="lg" />}
        title="Calculando os itens novos"
        description="Estamos comparando a tabela de preços com o resultado do motor de hoje."
        dismissible={false}
      />

      <ActionFeedbackDialog
        open={Boolean(confirmPreview)}
        type="info"
        title="Reprocessar a tabela de preços?"
        description={
          confirmPreview ? (
            <>
              <RerunCountList items={previewCounts(confirmPreview)} />
              <p className={styles.dialogNote}>Só é possível reprocessar uma vez por dia. Os preços aplicados ou editados hoje não são alterados.</p>
            </>
          ) : (
            ''
          )
        }
        dismissible={!starting}
        onClose={onClose}
        // durante o início o POST já saiu: fechar aqui esconderia um reprocessamento que gasta o do dia
        secondaryAction={starting ? undefined : { label: 'CANCELAR', onClick: onClose }}
        primaryAction={{
          label: starting ? 'INICIANDO...' : 'REPROCESSAR',
          onClick: () => (dialog?.type === 'confirm' ? onConfirm(dialog.preview) : undefined),
        }}
      />

      <ActionFeedbackDialog
        open={dialog?.type === 'nothing'}
        type="info"
        title="Nenhum item novo para reprocessar"
        description={
          dialog?.type === 'nothing' ? (
            <>
              <p>A tabela de preços não tem itens novos ou alterados desde a rodada do motor de hoje.</p>
              {hasSkipped(dialog.preview) ? <RerunCountList items={previewCounts(dialog.preview).slice(1)} /> : null}
            </>
          ) : (
            ''
          )
        }
        onClose={onClose}
        primaryAction={{ label: 'FECHAR', onClick: onClose }}
      />

      <ActionFeedbackDialog
        open={dialog?.type === 'error'}
        type="warning"
        title="Não foi possível reprocessar"
        description={dialog?.type === 'error' ? dialog.message : ''}
        onClose={onClose}
        primaryAction={{ label: 'FECHAR', onClick: onClose }}
      />
    </>
  );
};
